import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ExcTranslation} from 'exc-core-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';

@Component({
  selector: 'app-modal-leistung-position',
  templateUrl: './modal-leistung-position.component.html',
  styles: [
  ]
})
export class ModalLeistungPositionComponent extends ExcTranslation implements OnInit {
  @Input() data: {
    leID: string;
    priceList: any[];
    position: any;
    isOwner: boolean;
  } = {leID: '', priceList: [], position: undefined, isOwner: false};

  types = [
    {text: 'Honorarleistung', ident: 1},
    {text: 'Fahrtkosten', ident: 2},
    {text: 'Sonstige Kosten', ident: 3},
    {text: 'Auslagen', ident: 4}
  ];

  typeIndex = 0;
  type = 'Honorarleistung';
  typeIdent = 1;
  provIndex = -1;
  descIndex = -1;

  provListData: any[] = [];
  descListData: any[] = [];

  date: number = Date.now();
  desc = '';
  amount: any;
  unit = '';
  single: any;
  currency = '';
  netto: any;
  proof = '';
  comment = '';
  internalPosition = false;
  invoicePrice: any;
  invoiceAmount: any;
  invoiceComment = '';

  amountHour = 0;
  amountMinute = 0;
  amountInvoiceHour = 0;
  amountInvoiceMinute = 0;

  dateLocked = false;
  provLocked = false;
  descLocked = false;

  createMore = false;
  created = false;
  initialState = '';
  initialInvoiceAmount: any;

  constructor(
    public modal: ExgModalService,
    private excRestService: ExcRestService,
    public excSecurity: ExcSecurityService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data.position) {
      this.initFromPosition(this.data.position);
      this.convertAmountToHourMinute();
      this.convertInvoiceAmountToHourMinute();
      return;
    }
    this.refreshLists();
  }

  initFromPosition(position: any): void {
    this.typeIndex = this.types.findIndex(t => t.text === position.lstgType);
    this.type = this.types[this.typeIndex]?.text;
    this.typeIdent = this.types[this.typeIndex]?.ident;
    this.refreshLists();
    this.date = position.lstgDate;
    this.desc = position.lstgDescription;
    this.amount = position.lstgAmount;
    this.unit = position.lstgUnit;
    this.single = position.lstgPrice;
    this.currency = position.lstgCurrency;
    this.netto = position.lstgNetPrice;
    this.proof = position.lstgNumber;
    this.comment = position.lstgComment;
    this.internalPosition = position.lstgInternalPosition;
    this.invoicePrice = position.lstgInvoicePrice;
    this.invoiceAmount = position.lstgInvoiceAmount;
    this.invoiceComment = position.lstgInvoiceComment;
    this.provIndex = this.provListData.findIndex(p => p.text === position.lstgProvider);
    this.descIndex = this.descListData.findIndex(d => d.text === position.lstgDescription);
    this.initialState = JSON.stringify(this.payload());
    this.initialInvoiceAmount = this.invoiceAmount;
  }

  isExpense(): boolean {
    return this.type === 'Auslagen';
  }

  hasDescList(): boolean {
    return this.type !== 'Honorarleistung';
  }

  isHourUnit(): boolean {
    return this.unit === 'Stunde';
  }

  showInvoice(): boolean {
    return this.excSecurity.isFeatured('LSTGINTERNAL') && !this.isExpense();
  }

  refreshLists(): void {
    this.provListData = (this.data.priceList || [])
      .filter(e => e.lstgErbringer)
      .map(e => ({text: e.lstgErbringer}));
    this.descListData = (this.data.priceList || [])
      .filter(e => e.lstgKategorie === this.typeIdent && e.lstgBeschreibung)
      .map(e => ({text: e.lstgBeschreibung}));
  }

  changeType(): void {
    this.type = this.types[this.typeIndex]?.text;
    this.typeIdent = this.types[this.typeIndex]?.ident;
    this.refreshLists();
    this.provIndex = -1;
    this.descIndex = -1;
    this.unit = this.isExpense() ? 'Euro' : '';
    this.single = undefined;
    this.currency = '';
    this.amount = this.isExpense() ? 1 : undefined;
    this.invoiceAmount = undefined;
    this.invoiceComment = '';
    this.amountHour = 0;
    this.amountMinute = 0;
    this.amountInvoiceHour = 0;
    this.amountInvoiceMinute = 0;
  }

  changeProv(): void {
    this.applyPriceListEntry((this.data.priceList || [])
      .find(e => e.lstgErbringer === this.provListData[this.provIndex]?.text));
  }

  changeDesc(): void {
    this.desc = this.descListData[this.descIndex]?.text;
    this.applyPriceListEntry((this.data.priceList || [])
      .find(e => e.lstgBeschreibung === this.desc));
  }

  applyPriceListEntry(entry: any): void {
    if (!entry) {
      return;
    }
    this.unit = entry.Einheit;
    this.currency = entry.Währung;
    this.single = entry.lstgEinkaufspreis;
    this.invoicePrice = entry.lstgVerkaufspreis;
    this.convertAmountToHourMinute();
    this.convertInvoiceAmountToHourMinute();
  }

  changeNetto(): void {
    this.single = this.netto;
  }

  changeAmount(value: any): void {
    if (!this.isInvoiceAmountUpdated() && !this.data.position) {
      this.invoiceAmount = Number(value);
      this.convertInvoiceAmountToHourMinute();
      this.initialInvoiceAmount = Number(value);
    }
    this.convertAmountToHourMinute();
  }

  convertHourMinuteToAmount(): void {
    const hours = this.amountHour || 0;
    const minutes = (this.amountMinute || 0) / 60;
    this.amount = parseFloat(hours.toString()) + parseFloat(minutes.toFixed(2));
    this.changeAmount(this.amount);
  }

  convertAmountToHourMinute(): void {
    const minutes = Math.round((this.amount || 0) * 60);
    this.amountMinute = minutes % 60;
    this.amountHour = (minutes - this.amountMinute) / 60;
  }

  convertInvoiceHourMinuteToAmount(): void {
    const hours = this.amountInvoiceHour || 0;
    const minutes = (this.amountInvoiceMinute || 0) / 60;
    this.invoiceAmount = parseFloat(hours.toString()) + parseFloat(minutes.toFixed(2));
  }

  convertInvoiceAmountToHourMinute(): void {
    const minutes = Math.round((this.invoiceAmount || 0) * 60);
    this.amountInvoiceMinute = minutes % 60;
    this.amountInvoiceHour = (minutes - this.amountInvoiceMinute) / 60;
  }

  isInvoiceAmountUpdated(): boolean {
    return this.initialInvoiceAmount !== undefined && this.initialInvoiceAmount !== Number(this.invoiceAmount);
  }

  isModelUpdated(): boolean {
    return this.initialState !== JSON.stringify(this.payload());
  }

  valid(): boolean {
    if (!this.date || !this.desc) {
      return false;
    }
    if (!this.isExpense() && this.provIndex < 0) {
      return false;
    }
    if (this.isExpense()) {
      return this.netto !== undefined && this.netto !== null && this.netto !== '';
    }
    return this.amount !== undefined && this.amount !== null && this.amount !== '';
  }

  payload(): any {
    return {
      leID: this.data.leID,
      Type: this.type,
      Date: this.date,
      Provider: this.provListData[this.provIndex]?.text,
      Description: this.desc,
      Amount: this.amount,
      Unit: this.unit,
      Price: this.single,
      Currency: this.currency,
      NetPrice: this.netto,
      Number: this.proof,
      Comment: this.comment,
      InternalPosition: this.internalPosition,
      InvoicePrice: this.invoicePrice,
      InvoiceAmount: this.invoiceAmount,
      InvoiceComment: this.invoiceComment
    };
  }

  save(): void {
    if (!this.valid()) {
      this.modal.showToast(
        this.getRessource('FieldsRequired'),
        'md-toast',
        'fas fa-exclamation'
      );
      return;
    }
    if (!this.data.position) {
      this.create();
      return;
    }
    if (!this.isModelUpdated()) {
      this.modal.close();
      return;
    }
    if (this.data.isOwner) {
      this.update();
      return;
    }
    this.modal.show('ModalLeistungStateChangeComponent', {
      leID: this.data.leID,
      relation: JSON.stringify(this.data.position),
      commentRequired: true,
      headerText: this.getRessource('EditReasonHeader'),
      description: this.getRessource('EditReasonDescription')
    }).subscribe((response: any) => {
      if (response) {
        this.update(response.comment);
      }
    });
  }

  create(): void {
    this.excRestService.post(
      this.excRestService.computeUrl('LeistungserfassungLeistungCreate', {}),
      this.payload(),
      {}
    ).subscribe((response: any) => {
      if (response?.success) {
        this.created = true;
        if (this.createMore) {
          this.resetFields();
          return;
        }
        this.modal.action(true);
        this.modal.close();
      }
    });
  }

  resetFields(): void {
    if (!this.dateLocked) {
      this.date = Date.now();
    }
    if (!this.provLocked) {
      this.provIndex = -1;
    }
    if (!this.descLocked) {
      this.descIndex = -1;
      this.desc = '';
    }
    if (!this.provLocked && !this.descLocked) {
      this.unit = this.isExpense() ? 'Euro' : '';
      this.single = undefined;
      this.currency = '';
      this.invoicePrice = undefined;
    }
    this.amount = this.isExpense() ? 1 : undefined;
    this.netto = undefined;
    this.proof = '';
    this.comment = '';
    this.internalPosition = false;
    this.invoiceAmount = undefined;
    this.invoiceComment = '';
    this.initialInvoiceAmount = undefined;
    this.amountHour = 0;
    this.amountMinute = 0;
    this.amountInvoiceHour = 0;
    this.amountInvoiceMinute = 0;
  }

  update(reason?: string): void {
    const updobj: any = this.payload();
    updobj.lstgID = this.data.position.lstgID;
    updobj.UPT = this.data.position.lstgUPT;
    updobj.CreateNr = this.data.position.lstgCreateNr;
    updobj.lstgChangedReason = reason;
    this.excRestService.put(
      this.excRestService.computeUrl('LeistungserfassungLeistungUpdate', {}),
      updobj,
      {}
    ).subscribe(() => {
      this.modal.action(true);
      this.modal.close();
    });
  }

  cancel(): void {
    if (this.created) {
      this.modal.action(true);
    }
    this.modal.close();
  }

}
